/**
 * @generated SignedSource<<01d1e7176c48bfdc6261093296357df3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatusColumnHeaderOld_column$data = {
  readonly collapsed: boolean;
  readonly statuses: ReadonlyArray<{
    readonly name: string;
    readonly statusCategory: {
      readonly statusCategoryId: string;
    };
    readonly statusId: string;
    readonly " $fragmentSpreads": FragmentRefs<"BoardHeaderDropdown_status" | "ColumnConfettiAsync_status">;
  } | null | undefined>;
  readonly " $fragmentType": "StatusColumnHeaderOld_column";
};
export type StatusColumnHeaderOld_column$key = {
  readonly " $data"?: StatusColumnHeaderOld_column$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusColumnHeaderOld_column">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StatusColumnHeaderOld_column",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "collapsed"
      },
      "action": "THROW",
      "path": "collapsed"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "statuses",
        "plural": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BoardHeaderDropdown_status"
          },
          {
            "kind": "FragmentSpread",
            "name": "ColumnConfettiAsync_status"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "name"
            },
            "action": "THROW",
            "path": "statuses.name"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "statusId"
            },
            "action": "THROW",
            "path": "statuses.statusId"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraStatusCategory",
              "kind": "LinkedField",
              "name": "statusCategory",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                  },
                  "action": "THROW",
                  "path": "statuses.statusCategory.statusCategoryId"
                }
              ]
            },
            "action": "THROW",
            "path": "statuses.statusCategory"
          }
        ]
      },
      "action": "THROW",
      "path": "statuses"
    }
  ],
  "type": "JiraBoardViewStatusColumn"
};

(node as any).hash = "4c0bdd02c1b8f62d3b0430bb21d17916";

export default node;
